<template>
  <div class="finacial-flow-chart-view2-multi-currency">
    <div class="section operations" style="margin-bottom:2px;">
      <el-form inline style="margin-bottom:-12px;">
        <!--科目-->
        <el-form-item :label="$t('CargoMsg.Cargo_AccountTitle')">
          <el-select ref="accountTitleRef" v-model="form.accountTitle" style="width: 300px;" :filterable="true" :clearable="true" no="1">
            <el-option
              v-for="(item,index) in accountTitleCollection"
              :key="index"
              :label="accountTitleLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <!--会计日期-->
        <el-form-item :label="$t('CargoMsg.AccountingDate')">
          <el-date-picker
            ref="documentDateRef"
            v-model="form.documentDate"
            format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            :default-value="defaultDate"
            style="width: 128px;"
            no="2"
          />
        </el-form-item>
        <!--币种-->
        <el-form-item :label="$t('CargoMsg.Cargo_Currency')">
          <el-select v-model="form.currency" style="width: 100px;" no="3">
            <el-option
              v-for="item in usedCurrencyCollection"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <!--摘要-->
        <el-form-item :label="$t('CargoMsg.Cargo_Abstract')">
          <el-input v-model="form.summaryText" style="width: 300px;" no="4" />
        </el-form-item>
        <br>
        <!--客户-->
        <el-form-item :label="$t('CargoMsg.Cargo_Customer')">
          <cargo-advance-select
            :callback-params="{key:'customer'}"
            :default-value="form.customer"
            :select-type="selectTypeNames.basic_data_Company"
            callback-method-type="value"
            filterable
            style="width: 300px;"
            no="5"
            @parentCallBack="selectChangeHandler"
          />
        </el-form-item>
        <!--部门-->
        <el-form-item :label="$t('CargoMsg.Cargo_Department')">
          <cargo-advance-select
            v-show="false"
            :callback-params="{key:'departmentId'}"
            :default-value="form.departmentId"
            :select-type="selectTypeNames.basic_data_Department"
            :method-params="{officeUuid:$store.getters.currentOfficeUuid}"
            callback-method-type="value"
            filterable
            style="width: 120px;"
            no="6"
            @parentCallBack="selectChangeHandler"
          />
          <office-department-cascader
            v-model="form.departmentIds"
            :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
            style="width: 298px;"
            no="7"
          />
        </el-form-item>
        <!--销售-->
        <el-form-item :label="$t('CargoMsg.Cargo_Sales')">
          <cargo-advance-select
            :callback-params="{key:'sales'}"
            :default-value="form.sales"
            :select-type="selectTypeNames.basic_data_User"
            callback-method-type="value"
            filterable
            style="width: 140px;"
            no="8"
            @parentCallBack="selectChangeHandler"
          />
        </el-form-item>
        <el-form-item>
          <!--显示明细科目-->
          <el-checkbox v-model="form.showItems" :label="$t('CargoMsg.Cargo_ShowDetailedTitles')" no="9" />
          <!--含期末调汇分录-->
          <el-checkbox v-model="form.showAdjustRateEntry" :label="$t('CargoMsg.Cargo_ShowAdjustRateEntry')" no="10" />
          <!--查询-->
          <el-button class="el-margin" type="primary" style="margin-left: 20px;" no="11" @click="doSearch">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="section" style="flex: 1;padding: 0px;">
      <cargo-ag-grid
        :show-side-bar="false"
        :column-defs="columnDefs"
        :grid-options="gridOptions"
        :grid-params.sync="girdParams"
        :row-data="rowData"
        :auto-fit-content="false"
        style="height: 800px;"
        no="12"
      />
    </div>
    <accounting-entry-window
      v-if="accountingEntryWindow.visible"
      :account-set="accountSet"
      :account-title-data-provider="accountingEntryWindow.accountTitleDataProvider"
      :index="accountingEntryWindow.index"
      :is-ext="isExt"
      :mapping-departments="mappingDepartments"
      :mapping-staffs="mappingStaffs"
      :prefix-data-provider="accountingDocumentTypes"
      :visible="accountingEntryWindow.visible"
      :voucher="accountingEntryWindow.voucher"
      no="13"
      @close="() => accountingEntryWindow.visible=false"
    />
  </div>
</template>

<script>
import * as NumberUtils from '@/utils/NumberUtils'
import { cache } from '@/utils/cacheManager'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as accountingEntryApi from '@/api/financeManage/accountingEntry'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { formatNumberToThousands } from '@/utils'
import AccountingEntryWindow from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/AccountingEntryWindow'
import DateUtils from '@/utils/dateUtils'
import * as accountingDocumentApi from '@/api/financeManage/accountingDocument'
import ColumnUtils from '@/utils/ColumnUtils'
import officeDepartmentCascader from '@/components/Cargo/Common/officeDepartmentCascader'

export default {
  name: 'FinacialFlowChartView2MultiCurrencyDay',
  components: { cargoAdvanceSelect, AccountingEntryWindow, officeDepartmentCascader },
  props: {
    accountSet: { type: Object, default: null },
    usedCurrencyCollection: { type: Array, default: null }
  },
  data() {
    return {
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          minWidth: 80,
          menuTabs: [], // 去掉每列的菜单
          sortable: false // 去掉每列的排序
        },
        suppressContextMenu: false,
        getContextMenuItems: () => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport'),
              action: function() {
                self.exportExcelHandler()
              }
            }
          ]
        },
        onCellDoubleClicked: event => {
          this.doubleClickHandler(event.data)
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 180,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
              field: 'ACCOUNT_TITLE',
              width: 180,
              valueFormatter: params => {
                const item = params.data
                if (item.ACCOUNT_TITLE !== '') {
                  return item.ACCOUNT_TITLE + '_' + item.ACCOUNT_TITLE_NAME
                }
                return ''
              }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 100,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_ProofDate'),
              field: 'DOCUMENT_DATE',
              width: 100
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 100,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_VoucherNo'),
              field: 'DOCUMENT_NO',
              width: 100,
              cellStyle: { textAlign: 'right' }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 260,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Abstract'),
              field: 'SUMMARY',
              width: 260,
              cellRenderer: params => {
                const value = params.value
                if (value === this.$t('CargoMsg.Cargo_OpeningBalance') || value === this.$t('CargoMsg.CurrentDayAmountTo') ||
                  value === this.$t('CargoMsg.TotalReportingCurrencyOfThisDay')) {
                  return `<span style="font-weight: bold;font-family: 宋体,serif;font-style: italic;font-size: 14px">${value}</span>`
                } else {
                  return `<span style="font-weight: normal;font-style: normal;font-size: 12px">${value}</span>`
                }
              }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 80,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Currency'),
              field: 'SOURCE_CURRENCY',
              width: 80,
              cellStyle: { textAlign: 'center' }
            }
          ]
        },
        {
          headerName: '\u3000\u3000\u3000\u3000\u3000' + this.$t('CargoMsg.Cargo_DebitAmountOccurred'),
          field: '',
          width: 220,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_SourceAmount'),
              field: 'DEBIT_USD',
              width: 110,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }, {
              headerName: this.$t('CargoMsg.Cargo_LocalAmount'),
              field: 'DEBIT_RMB',
              width: 110,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }
          ]
        },
        {
          headerName: '\u3000\u3000\u3000\u3000\u3000' + this.$t('CargoMsg.Cargo_CreditAmountOccurred'),
          field: '',
          width: 220,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_SourceAmount'),
              field: 'CREDIT_USD',
              width: 110,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }, {
              headerName: this.$t('CargoMsg.Cargo_LocalAmount'),
              field: 'CREDIT_RMB',
              width: 110,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 80,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Loan'),
              field: 'DEBIT_CREBIT',
              width: 80,
              cellStyle: { textAlign: 'center' }
            }
          ]
        },
        {
          headerName: '\u3000\u3000\u3000\u3000\u3000\u3000' + this.$t('CargoMsg.Cargo_Balance'),
          field: '',
          width: 220,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_SourceAmount'),
              field: 'BALANCE_USD_SUM',
              width: 110,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }, {
              headerName: this.$t('CargoMsg.Cargo_LocalAmount'),
              field: 'BALANCE_RMB_SUM',
              width: 110,
              valueFormatter: params => {
                return formatNumberToThousands(this.numberFormat(params.value), 2)
              },
              cellStyle: { textAlign: 'right' }
            }
          ]
        },
        {
          headerName: '',
          field: '',
          width: 240,
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_Department'),
              field: 'DEPARTMENT',
              width: 120,
              cellRenderer: params => {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
              }
            }, {
              headerName: this.$t('CargoMsg.Cargo_Salesman'),
              field: 'SALES',
              width: 120,
              cellRenderer: params => {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
              }
            }
          ]
        }
      ],
      columnDefsRMB: [
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
          field: 'ACCOUNT_TITLE',
          width: 180,
          valueFormatter: params => {
            const item = params.data
            if (item.ACCOUNT_TITLE !== '') {
              return item.ACCOUNT_TITLE + '_' + item.ACCOUNT_TITLE_NAME
            }
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProofDate'),
          field: 'DOCUMENT_DATE',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VoucherNo'),
          field: 'DOCUMENT_NO',
          width: 100,
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Abstract'),
          field: 'SUMMARY',
          width: 260,
          cellRenderer: params => {
            const value = params.value
            if (value === this.$t('CargoMsg.Cargo_OpeningBalance') || value === this.$t('CargoMsg.CurrentDayAmountTo')) {
              return `<span style="font-weight: bold;font-family: 宋体,serif;font-style: italic;font-size: 14px">${value}</span>`
            } else {
              return `<span style="font-weight: normal;font-style: normal;font-size: 12px">${value}</span>`
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'SOURCE_CURRENCY',
          width: 80,
          cellStyle: { textAlign: 'center' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DebitAmountOccurred'),
          field: 'DEBIT_RMB',
          width: 110,
          valueFormatter: params => {
            return formatNumberToThousands(this.numberFormat(params.value), 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CreditAmountOccurred'),
          field: 'CREDIT_RMB',
          width: 110,
          valueFormatter: params => {
            return formatNumberToThousands(this.numberFormat(params.value), 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Loan'),
          field: 'DEBIT_CREBIT',
          width: 80,
          cellStyle: { textAlign: 'center' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Balance'),
          field: 'BALANCE_RMB_SUM',
          width: 110,
          valueFormatter: params => {
            return formatNumberToThousands(this.numberFormat(params.value), 2)
          },
          cellStyle: { textAlign: 'right' }
        }
      ],
      excelColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
          field: 'ACCOUNT_TITLE',
          width: 100,
          cellRenderer: params => {
            const item = params.data
            if (item.ACCOUNT_TITLE !== '') {
              return item.ACCOUNT_TITLE + '_' + item.ACCOUNT_TITLE_NAME
            }
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProofDate'),
          field: 'DOCUMENT_DATE',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VoucherNo'),
          field: 'DOCUMENT_NO',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Abstract'),
          field: 'SUMMARY',
          width: 100,
          cellRenderer: params => {
            const value = params.value
            if (value === this.$t('CargoMsg.Cargo_OpeningBalance') || value === this.$t('CargoMsg.CurrentDayAmountTo')) {
              return value
            } else {
              return value || ''
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'SOURCE_CURRENCY',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DebitAmountOccurredSource'),
          field: 'DEBIT_USD',
          width: 100,
          convertToNumber: true,
          cellRenderer: params => {
            return this.numberFormat(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DebitAmountOccurredLocal'),
          field: 'DEBIT_RMB',
          width: 100,
          convertToNumber: true,
          cellRenderer: params => {
            return this.numberFormat(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CreditAmountOccurredSource'),
          field: 'CREDIT_USD',
          width: 100,
          convertToNumber: true,
          cellRenderer: params => {
            return this.numberFormat(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CreditAmountOccurredLocal'),
          field: 'CREDIT_RMB',
          width: 100,
          convertToNumber: true,
          cellRenderer: params => {
            return this.numberFormat(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Loan'),
          field: 'DEBIT_CREBIT',
          convertToNumber: true,
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BalanceSource'),
          field: 'BALANCE_USD_SUM',
          convertToNumber: true,
          width: 100,
          cellRenderer: params => {
            return this.numberFormat(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BalanceLocal'),
          field: 'BALANCE_RMB_SUM',
          convertToNumber: true,
          width: 100,
          cellRenderer: params => {
            return this.numberFormat(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Department'),
          field: 'DEPARTMENT',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Salesman'),
          field: 'SALES',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }
      ],
      rowData: [],
      selectTypeNames: TYPE_NAMES,
      fpSelectDataProvider: [],
      form: {
        accountTitle: null,
        documentDate: '',
        currency: '',
        summaryText: '',
        customer: 0,
        departmentId: null,
        departmentIds: [],
        sales: 0,
        showItems: true,
        showAdjustRateEntry: false
      },
      accountingEntryWindow: {
        visible: false,
        index: -1,
        voucher: null,
        accountTitleDataProvider: []
      },
      dateRange: [],
      today: ColumnUtils.dateLabelFunc(new Date()),
      nowYear: new Date().getFullYear(),
      defaultDate: null,
      pickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledDate
      }
    }
  },
  computed: {
    // 科目
    accountTitleCollection() {
      return this.accountSet ? this.accountSet.accountTitle : []
    },
    // 部门编码映射
    mappingDepartments() {
      return this.accountSet ? this.accountSet.mappingDepartments : []
    },
    // 凭证类型
    accountingDocumentTypes() {
      return this.accountSet ? this.accountSet.accountingDocumentType : []
    },
    isExt() {
      return Number(cache.config.get('ext')) === 1
    },
    // 职员
    mappingStaffs() {
      return this.accountSet ? this.accountSet.mappingStaffs : []
    }
  },
  watch: {
    accountSet() {
      this.accountSetChange()
    }
  },
  created() {
    this.accountSetChange()
  },
  methods: {
    async accountSetChange() {
      if (this.accountSet) {
        this.form.currency = this.usedCurrencyCollection[0]
        const loading = getLoading4Cxt(this)
        try {
          await this.loadDateRange(this.nowYear)
          if (this.dateRange.length > 0) {
            setTimeout(() => {
              this.loadDateRange()
            }, 100)
          } else {
            await this.loadDateRange()
          }
          if (this.dateRange.length > 0) {
            if (this.dateRange.includes(this.today)) {
              this.form.documentDate = this.today
            } else {
              this.form.documentDate = this.dateRange[this.dateRange.length - 1]
            }
          } else {
            this.form.documentDate = ''
          }
          this.defaultDate = this.form.documentDate
        } finally {
          loading.close()
        }
      } else {
        this.dateRange = []
        this.form.documentDate = ''
        this.defaultDate = ''
      }
    },
    async loadDateRange(year = '') {
      const res = await accountingEntryApi.getSubLedgerDailyReportDateRange({ accountSetUuid: this.accountSet.uuid, year })
      this.dateRange = Array.from(res.data, p => ColumnUtils.dateLabelFunc(p))
    },
    numberFormat(value) {
      if (value) {
        return NumberUtils.formatRoundNumber(value, 2)
      }
      return ''
    },
    accountTitleLabelFun(accountTitle) {
      return accountTitle ? accountTitle.accountTitle + '_' + accountTitle.accountTitleName : ''
    },
    selectChangeHandler(params) {
      this.form[params.key] = params.value
    },
    doSearch() {
      const allowNoTitle = parseInt(cache.config.get('AccountBookExportDetails')) === 1
      if (!this.form.accountTitle && allowNoTitle) {
        this.$refs.accountTitleRef.focus()
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectAccountTitle'), this.$t('CargoMsg.Cargo_Tips'))
        return
      }
      if (!this.form.documentDate) {
        this.$refs.documentDateRef.focus()
        this.$message.warning(this.$t('CargoMsg.PleaseSelectAccountDate'), this.$t('CargoMsg.Cargo_Tips'))
        return
      }
      const strs = this.form.documentDate.split('-')
      const year = Number(strs[0])
      const month = Number(strs[1])
      const obj = {}
      Object.assign(obj, this.form)
      obj.accountSet = this.accountSet.uuid
      obj.year = year
      obj.documentMonthStart = month
      obj.yearSearch = year
      obj.documentMonthEnd = month
      if (this.form.accountTitle) {
        const accountTitle = this.accountTitleCollection.find(title => title.uuid === this.form.accountTitle)
        obj.accountTitle = accountTitle ? accountTitle.accountTitle : ''
      }
      if (!this.form.sales) {
        obj.sales = undefined
      }
      if (!this.form.departmentId) {
        obj.departmentId = undefined
      }
      if (this.form.departmentIds.length > 0) {
        const set = new Set()
        for (const item of this.form.departmentIds) {
          for (let i = 1; i < item.length; ++i) {
            set.add(item[i])
          }
        }
        obj.departmentIds = [...set].join(',')
      } else {
        obj.departmentIds = undefined
      }
      if (!this.form.customer) {
        obj.customer = undefined
      }
      if (this.form.currency && this.form.currency !== this.$t('CargoMsg.Cargo_ConsolidatedLocalCurrency')) {
        obj.currency = this.form.currency
      } else {
        obj.currency = undefined
      }
      if (!this.form.summaryText) {
        obj.summaryText = undefined
      }
      if (!this.form.showItems) {
        obj.showItems = undefined
      }
      this.setColumnVisible()
      const loading = getLoading()
      accountingEntryApi.getAccountingEntriesForFlowChart2ByMultiCurrencyDay({ conditionMap: obj }).then(resp => {
        this.rowData = resp.data
      }).finally(() => loading.close())
    },
    setColumnVisible() {
      this.gridOptions.api.setColumnDefs([])
      if (this.form.currency !== this.accountSet.localCurrency) {
        this.gridOptions.api.setColumnDefs(this.columnDefs)
      } else {
        this.gridOptions.api.setColumnDefs(this.columnDefsRMB)
      }
    },
    exportExcelHandler() {
      const columnDefs = []
      this.excelColumnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportExcel(this.$t('FinanceManage.SubsidiaryLedger'), this.rowData, columnDefs)
    },
    doubleClickHandler(data) {
      if (data) {
        // 凭证号
        const documentNo = data['DOCUMENT_NO']
        // 凭证日期
        const documentDate = data['DOCUMENT_DATE']
        if (documentNo != null && documentNo !== '' && documentDate != null && documentDate !== '') {
          const obj = {}
          obj['startDate'] = DateUtils.formatStandardDate(new Date(documentDate))
          obj['endDate'] = obj['startDate']
          obj['documentNoFrom'] = documentNo
          obj['documentNoTo'] = documentNo
          const params = {}
          params.accountingSetKey = this.accountSet.uuid
          params.condition = obj
          accountingDocumentApi.query(params).then(resp => {
            this.resultHandler(resp)
          })
        }
      }
    },
    resultHandler(resp) {
      const data = resp.data
      if (data) {
        if (this.isExt) {
          this.accountingEntryWindow.accountTitleDataProvider = this.accountTitleDataProvider
        }
        this.accountingEntryWindow.voucher = data.list
        this.accountingEntryWindow.index = 0
        this.accountingEntryWindow.visible = true
      }
    },
    // 设置不可选日期范围
    disabledDate(curTime) {
      const curDate = ColumnUtils.dateLabelFunc(curTime)
      return !this.dateRange.includes(curDate)
    }
  }
}
</script>

<style scoped>
  .el-margin{
    margin: 0 0 5px 5px;
  }
</style>
